import { ActionType } from 'typesafe-actions';
import { Project } from '../projects';
import * as actions from './actions';

export type AuthAction = ActionType<typeof actions>;

export interface AuthState {
  auth: {
    data: User | null;
    loading: boolean;
    error: Error | null;
  };
  myEnterprise: {
    data: Enterprise | null;
    loading: boolean;
    error: Error | null;
  };
  isLoggedIn: boolean;
}

export interface User {
  id: number;
  projectId?: string;
  name: string;
  email: string;
  myEnterprise: Partial<Enterprise>;
  project: Partial<Project>;
  permission: string;
  createdAt: string;
  updatedAt: string;
  personalPhone: string;
  signatureFileName: string;
  signatureFilePath: string;
  userId: number;
  workPhone: string;
  workPosition: string;
  team: string;
  workStatus: string;
  token?: string;
  roleName: string;
  isEnabled: boolean;
  oAuth20Tokens: OAuth20Token[];
}

export interface LoginResponse {
  token: string;
  user: User;
}

export interface Enterprise {
  id: number;
  projectId?: number;
  name: string;
  representative: string;
  address: string;
  detailAddress?: string;
  type1: EnterpriseType1;
  category: string;
  corporateNumber: string;
  corporatePhone: string;
  employees: User[];
  type2: string[];
  workPerformed: string[];
  region: string[];
  prequalificationData: any;
  createdAt: string;
  updatedAt: string;
  expenseConfig: any;
  vendorConfig: any;
}

export interface EnterpriseParams {
  enterpriseId: string;
  enterprise?: Enterprise;
}

export interface UserParams {
  enterpriseId?: string;
  userId?: string;
  user?: Partial<User>;
  redirectUrl?: string;
}

export interface RegisterParams {
  enterpriseId?: string;
  applicationId?: string;
  enterprise?: Partial<Enterprise>;
  user: Partial<User>;
  redirectUrl?: string;
  token?: string;
}

export const emailInvitationStatusKorean = {
  '0': '초대 안됨',
  '1': '초대 완료',
  '2': '수락',
  '3': '거절',
} as const;

export enum EmailInvitationStatus {
  NOT_INVITED = '0',
  INVITED = '1',
  ACCEPTED = '2',
  DECLINED = '3',
}

export enum EmailInvitationType {
  PARTNER = '0',
  BIDDER = '1',
}

export interface EmailInvitation {
  id: number;
  email: string;
  userName: string;
  companyName: string;
  sendCount: number;
  createdAt: string;
  type: EmailInvitationType;
  status: EmailInvitationStatus;
  sender: User;
  enterprise?: Enterprise;
}

export interface EmailInvitationParams {
  enterpriseId: string;
  type?: EmailInvitationType;
  idList?: number[];
  email?: string;
  status?: EmailInvitationStatus;
  dto?: any;
}

export interface Tag {
  id: number;
  name: string;
  type: string;
}

export enum USER_ROLE_NAME {
  SUPERADMIN = '0',
  ADMIN = '1',
  MANAGER = '2',
  STAFF = '3',
}

export const roleNameKoreanEnum: any = {
  0: '슈퍼유저',
  1: '관리자',
  2: '매니저',
  3: '멤버',
  // foreman: '현장담당',
  // manager: '본사담당',
  // none: '없음',
} as const;
// export type RoleNameKoreanEnum =
//   typeof roleNameKoreanEnum[keyof typeof roleNameKoreanEnum];

interface OAuth20Token {
  id: number;
  type: string;
}

export const oAuth20TokenTypeEnum = {
  MODUSIGN: '0',
} as const;
export type OAuth20TokenType =
  (typeof oAuth20TokenTypeEnum)[keyof typeof oAuth20TokenTypeEnum];

export interface ModusignTemplate {
  id: string;
  file: any;
  participants: any[];
  title: string;
  createdAt: string;
  updatedAt: string;
}

export enum EnterpriseType1 {
  CONTRACTOR = '1',
  MATERIAL_VENDOR = '2',
  CLIENT = '3',
}

export const enterpriseType1Korean = {
  '1': '시공',
  '2': '자재',
  '3': '발주처',
} as const;

/*

{
  "count": 2,
  "templates": [
    {
      "id": "0fc12a00-5fcb-11ec-83b6-599c5a056f01",
      "metadatas": [],
      "file": {
        "downloadUrl": "https://api.modusign.co.kr/templates/0fc12a00-5fcb-11ec-83b6-599c5a056f01/file?signedUrlToken=%2Fmodusign-app%2Fdocuments%2F6de86d50-c035-11ea-a32d-d70911cd17b7%2Fe216a490-5fca-11ec-a904-6da0b707dd53.pdf%3FX-Amz-Algorithm%3DAWS4-HMAC-SHA256%26X-Amz-Credential%3DAKIA3EQMQCJY6N2PMGEF%252F20211231%252Fap-northeast-2%252Fs3%252Faws4_request%26X-Amz-Date%3D20211231T033744Z%26X-Amz-Expires%3D600%26X-Amz-Signature%3Df49a827c646f9f429896a6827688fb864d86c722afc618441c39ea203e0080a8%26X-Amz-SignedHeaders%3Dhost"
      },
      "participants": [
        {
          "role": "수급사업자",
          "signingOrder": 2,
          "name": null,
          "signingMethod": {
            "type": null,
            "value": null
          }
        },
        {
          "role": "원사업자",
          "signingOrder": 1,
          "name": null,
          "signingMethod": {
            "type": null,
            "value": null
          }
        }
      ],
      "title": "건설업종(2020.12.17.)",
      "createdAt": "2021-12-18T06:23:49.000Z",
      "updatedAt": "2021-12-18T06:47:50.000Z"
    },
    {
      "id": "1b679100-5e8b-11ec-83b6-599c5a056f01",
      "metadatas": [],
      "file": {
        "downloadUrl": "https://api.modusign.co.kr/templates/1b679100-5e8b-11ec-83b6-599c5a056f01/file?signedUrlToken=%2Fmodusign-app%2Fdocuments%2F6de86d50-c035-11ea-a32d-d70911cd17b7%2Fbc6c3a70-5e8a-11ec-ba9a-4157bc8df62f.pdf%3FX-Amz-Algorithm%3DAWS4-HMAC-SHA256%26X-Amz-Credential%3DAKIA3EQMQCJY6N2PMGEF%252F20211231%252Fap-northeast-2%252Fs3%252Faws4_request%26X-Amz-Date%3D20211231T033744Z%26X-Amz-Expires%3D600%26X-Amz-Signature%3Dd37b3acbea536f475ed889f24b9219a46b96fb2b5879877a8a39f65f6bb4b8b5%26X-Amz-SignedHeaders%3Dhost"
      },
      "participants": [
        {
          "role": "원사업자",
          "signingOrder": 1,
          "name": null,
          "signingMethod": {
            "type": null,
            "value": null
          }
        },
        {
          "role": "수급사업자",
          "signingOrder": 2,
          "name": null,
          "signingMethod": {
            "type": null,
            "value": null
          }
        }
      ],
      "title": "철근가공업종(2019.11.18.)",
      "createdAt": "2021-12-16T16:13:29.000Z",
      "updatedAt": "2021-12-16T16:53:37.000Z"
    }
  ]
}

*/
